import {FC, useState} from 'react'
import ReactSlider from 'react-slider'
import {isServiceActive} from "../../../lib/booking";

interface Props {
    title: string,
    type:string,
    active?:boolean,
    handle:Function,
    radio?:boolean
}

const CheckboxButton: FC<Props> = ({ title, type, active, handle, radio}) => {
    const handleClick = () => {
        if(radio)
            active = false

        handle(type, !active)
    }

    const className = 'btn btn--skyblue btn-service__action checkbox-button w-100 ' + (active ? 'checked' : '')
    return (
        <div className={className} onClick={() => handleClick()}>
            <div className="box"/>
            {active ? 'Vald' : title}
        </div>
    )
};

export default CheckboxButton
